import { useNotificationStore } from "@/store";

/** @note Request needs to be sent with { responseType: "blob" } */
export default function downloadFileFromResponse(response, notification = true) {
  // Extract filename from the Content-Disposition header
  const contentDisposition = response.headers['content-disposition'];
  let filename = 'Document.pdf'; // default filename

  if (contentDisposition) {
    filename = contentDisposition
      .split('; ')
      .find((param) => param.startsWith('filename='))
      ?.split('=')[1];
  }
  // Convert the data into a Blob
  const blob = new Blob([response.data], {type: response.headers['content-type'] || 'application/pdf'});

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', decodeURIComponent(filename));
  document.body.appendChild(link);
  link.click();

  if (notification) {
    useNotificationStore().emitNotification({
      type: "success",
      title: "Document généré avec succès"
    });
  }
}